import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { CompanyAppendix } from '../types';
import { PickedItem } from 'src/data-capture/file-management/drop-zone/SharePointButton';

type OneDriveFileItem = {
  fileName: string;
  downloadUrl: string;
  fileSize?: number;
};

type CreateOneDriveCompanyAppendixRequest = {
  files: OneDriveFileItem[];
};

export const useOneDriveCompanyAppendixUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const queryClient = useQueryClient();

  const uploadOneDriveFiles = async (items: PickedItem[]): Promise<CompanyAppendix[]> => {
    try {
      setIsUploading(true);
      const files: OneDriveFileItem[] = items
        .filter(item => item.name && item.downloadUrl)
        .map(item => ({
          fileName: item.name!,
          downloadUrl: item.downloadUrl!,
          fileSize: item.size,
        }));

      const response = await api.post<CompanyAppendix[]>('company-appendices/onedrive', {
        files,
      } satisfies CreateOneDriveCompanyAppendixRequest);

      await queryClient.invalidateQueries({ queryKey: ['company-appendices'] });

      return response.data;
    } finally {
      setIsUploading(false);
    }
  };

  return {
    uploadOneDriveFiles,
    isUploading,
  };
};
